class OfferFilters {

    constructor($) {
        this._$ = $;
    }

    _prepareFilters() {
        const baseParams = window.extractHrefParams();

        if( ! Object.keys(baseParams).length )
        {
            return window.fetchSearchResults();
        }

        let payload = {};

        document.querySelectorAll('input[data-filter-input], select[data-filter-input], textarea').forEach(input => {
            const valueExists = input.name in baseParams;
            let values = valueExists ? baseParams[input.name] : [];

            if( ! Array.isArray(values) )
            {
                values = [values];
            }

            values.forEach(value => {
                switch(input.nodeName)
                {
                    case 'SELECT':
                        this._presetFilterSelect(input, value, valueExists);
                        break;
                    case 'TEXTAREA':
                        this._presetFilterGeneral(input, value, valueExists);
                        break;
                    default:
                        input.type === 'checkbox' ? this._presetFilterCheckbox(input, value, valueExists) : this._presetFilterGeneral(input, value, valueExists)
                }
            });

            if( input.type === 'checkbox' )
            {
                payload[ input.name ] = input.checked ? input.value : null;
            }
            else
            {
                payload[ input.name ] = input.value;
            }
        });

        document.querySelectorAll('.filters-upper-row input').forEach(input => {
            if(input.checked)
            {
                this._handleTopFilterChange({target: input});
            }
        });

        window.fetchSearchResults(payload, false);
    }

    _presetFilterSelect(input, value, wasSet) {
        input.querySelectorAll('option').forEach(option => {
            option.selected = wasSet && option.value === value;
        });
    }

    _presetFilterCheckbox(input, value, wasSet) {
        if( input.value === value )
        {
            input.checked = wasSet;
        }
    }

    _presetFilterGeneral(input, value, wasSet) {
        input.value = wasSet ? value : '';
    }

    _registerEvents() {
        this._$(document).on('change', '#filters input, #filters select, #sort', event => this._handleFilterChange(event))
                .on('change', '.filters-upper-row input', event => this._handleTopFilterChange(event))
                .on('click', '.filter-slider label', event => this._handleTopFilterClick(event))
                .on('click', '.more-filters-switch, .close-filters, .close-filters-button', event => this._handleFiltersPanelToggle(event))
                .on('click', '.filters-lower-row .form-group-label', event => this._handleLabelAccortions(event));
    }

    _handleFilterChange(event) {
        const $inputs = this._$('#filters input, #filters select, #sort');

        let i = 0;
        let inputs = {};

        $inputs.each((key, input) => {
            if( input.type === 'checkbox' )
            {
                inputs[ input.name ] = input.checked ? input.value : null;

                if( input.checked )
                {
                    let push = {};
                    push[input.name] = input.value;

                    this._$(document).trigger('url-manager:push', [push]);
                }
                else
                {
                    this._$(document).trigger('url-manager:remove', [input.name]);
                }
            }
            else
            {
                inputs[ input.name ] = input.value;


                let shouldPush = false;

                try {
                    let strVal = typeof input.value === 'number' ? input.value.toString() : input.value;
                    shouldPush = strVal !== null && strVal.length > 0;
                } catch(e) {
                    shouldPush = false;
                }


                if( shouldPush )
                {
                    let push = {};
                    push[input.name] = input.value;

                    this._$(document).trigger('url-manager:push', [push]);
                }
                else
                {
                    this._$(document).trigger('url-manager:remove', [input.name]);
                }
            }

            i++;
        });

        if( $inputs.length === i )
        {
            this._$(document).trigger('offers-pagination:reset');
            window.fetchSearchResults(inputs, false);
        }
    }

    _handleTopFilterChange({target}) {
        const $target = this._$(target);
        const label = $target.siblings('label').text();
        const $dropList = $target.closest('.dropdown-menu');
        const $button = $dropList.siblings('.filter-dropdown');
        const buttonText = $button.text().trim();
        const names = buttonText.split(',');
        const indexOfItem = names.indexOf(label);
        const inputLabel = document.querySelectorAll('label[for="' + target.id + '"]');
        const sliderLabel = document.querySelectorAll('label[data-filter="' + target.dataset.filter + '"]');

        if( indexOfItem > -1 )
        {
            names.splice(indexOfItem, 1);

            inputLabel.forEach(label => label.classList.remove('active'));

            if(sliderLabel.length > -1)
            {
                sliderLabel.forEach(label => label.classList.remove('active'));
            }

            if( ! names.length )
            {
                names.push('Wybierz');
            }
        }
        else
        {
            if(names.indexOf('Wybierz') > -1)
            {
                names.splice( names.indexOf('Wybierz'), 1 );
            }

            inputLabel.forEach(label => label.classList.add('active'));

            if(sliderLabel.length > -1)
            {
                sliderLabel.forEach(label => label.classList.add('active'));
            }

            names.push(label);
        }

        $button.text(names);
    }

    _handleTopFilterClick({target}) {
        if( !target.hasAttribute('data-filter') )
        {
            target = target.closest('label[data-filter]');
        }

        if( !target )
        {
            return;
        }

        const input = document.querySelector('input[data-filter="' + target.getAttribute('data-filter') + '"]');

        if( ! input )
        {
            return;
        }

        input.checked = ! input.checked;

        this._$(input).trigger('change');
    }

    _handleFiltersPanelToggle({target}) {
        target.classList.toggle('open');
        this._$( target.getAttribute('data-toggle') ).slideToggle(800);
    }

    _handleLabelAccortions({target}) {
        const $target = this._$(target);
        const $options = $target.next();

        if( window.innerWidth < 768)
        {
            target.classList.toggle('active');
            $options.slideToggle();
        }
    }

    static run($) {
        const self = new OfferFilters($);

        self._prepareFilters();
        self._registerEvents();
    }
}

try {
    (function($) {
        OfferFilters.run($);
    })(window.jQuery);
} catch(e) { console.log(e) }